import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruth3postPostScreenTruthAppsAppBindingsRoleDataStateApproveResponseSchema = jsonObject
export type tcpscreentruth3postPostScreenTruthAppsAppBindingsRoleDataStateApproveResponse = z.infer<typeof tcpscreentruth3postPostScreenTruthAppsAppBindingsRoleDataStateApproveResponseSchema>
export const tcpscreentruth3postPostScreenTruthAppsAppChromeRequirementsResponseSchema = jsonObject
export type tcpscreentruth3postPostScreenTruthAppsAppChromeRequirementsResponse = z.infer<typeof tcpscreentruth3postPostScreenTruthAppsAppChromeRequirementsResponseSchema>
